import { REACT_APP_ADMIN_LINK } from "../../utils";
import IntegrationIcon from "../../shared/icons/IntegrationIcon";
import { Link } from "react-router-dom";
import clsx from "clsx";

const IntegrationsButton = () => {
  return (
    <div
      className={clsx(
        window.location.pathname === `${REACT_APP_ADMIN_LINK}/integrations`
          ? "text-md group flex w-full items-center rounded-md bg-dm-brand-blue-100 py-2 pl-2 font-medium text-dm-gray-600"
          : "text-md group flex w-full items-center rounded-md py-2 pl-2 font-medium text-dm-gray-600"
      )}
    >
      <Link to={`${REACT_APP_ADMIN_LINK}/integrations`}>
        <IntegrationIcon classes="mr-2" />
        Integrations
      </Link>
    </div>
  );
};

export default IntegrationsButton;
